import React from "react";
import { EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../../core/security/SprintAccessRight";
import { EditAudioTechnicalAside } from "./EditAudioTechnicalAside";

export interface EditAudioTechnicalButtonAsideProps {
    fileRecordId: string;
    isDisabled: boolean;
    isLabeled?: boolean;
}

export const EditAudioTechnicalButtonAside: React.FunctionComponent<EditAudioTechnicalButtonAsideProps> = (
    props: EditAudioTechnicalButtonAsideProps
) => {
    const { fileRecordId, isLabeled, isDisabled } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                testId="edit-technical"
                disabled={isDisabled}
            />
            <EditAudioTechnicalAside
                fileRecordId={fileRecordId}
                isOpen={isOpen}
                onCancel={onClose}
                onSubmit={onClose}
            />
        </AuthorizationWrapper>
    );
};
